export default {
  countryCode: 'KY',
  regionLinks: [
    {
      title: 'George Town',
    },
  ],
};
